module.exports = __webpack_public_path__ + "img/mobile-screen-mb.0a5f5d1f.png";